import React from 'react';
import Toggle from 'src/components/Toggle/Toggle';

import CheckBox from '../CheckBox';
import SelectBox from '../SelectBox/SelectBox';

interface IBulkActionBarProps {
    selectedRows: number[];
    setSelectedRows: (ids: number[]) => void;
    allIds: number[];
    showOnlySelected?: boolean;
    onShowOnlySelectedChange?: (val: boolean) => void;
    toolbar?: React.ReactNode;
}

const BulkActionBar = ({ selectedRows, setSelectedRows, allIds, showOnlySelected, onShowOnlySelectedChange, toolbar }: IBulkActionBarProps) => {
    const isAllSelected = allIds.length > 0 && selectedRows.length === allIds.length;

    const selectedDisplayValue = { value: 'selected', label: `${selectedRows.length} Selected` };

    const bulkSelectOptions = [...(!isAllSelected ? [{ value: 'select_all', label: `Select all ${allIds.length} on page` }] : []), { value: 'unselect_all', label: 'Unselect all' }];

    const handleBulkSelectChange = (option: any) => {
        if (option?.value === 'select_all') {
            setSelectedRows(allIds);
        } else if (option?.value === 'unselect_all') {
            setSelectedRows([]);
        }
    };

    const handleToggleAll = () => {
        setSelectedRows(isAllSelected ? [] : allIds);
    };

    return (
        <div className="flex items-center gap-1.5 w-full bg-utilityGray100 border-b border-utilityGray200 px-3 py-[5.75px] overflow-auto custom-scrollbar h-[36.5px] absolute z-[1]">
            <CheckBox parentClassName="pr-2" id={`select-all`} checked={isAllSelected} onChangeFunc={handleToggleAll} name="selectQuote" />

            <SelectBox
                value={selectedDisplayValue}
                options={bulkSelectOptions}
                onChangeFunc={handleBulkSelectChange}
                size="sm"
                parentClassName="table-selection-selectbox table-selection-selectbox-transparent w-[120px] flex-none -ml-2"
                SelectDropdownWrapClass="table-selection-selectbox-dropdown filter-select-dropdown-md"
                isSearchable={false}
            />

            {toolbar && <>{toolbar}</>}

            {onShowOnlySelectedChange && (
                <Toggle
                    id="showAll"
                    isChecked={showOnlySelected ?? false}
                    onChange={() => onShowOnlySelectedChange(!showOnlySelected)}
                    label="Show all selected"
                    labelClassName="text-xs  ml-auto flex-none"
                    labelTextClassName="!font-mediun !text-grayLight600"
                    labelPosition="right"
                    size="sm"
                />
            )}
        </div>
    );
};

export default BulkActionBar;
